'use client';

import classNames from 'classnames';
import { ReactNode } from 'react';
import { CtaComponent } from '@sapientpro/sapientpro-data-models';
import styles from './CalculatorCTA.module.scss';
import AnimatedTitle from '../AnimatedTitle';
import { SUPPORTED_VIDEO_EXTENSIONS } from '../../../constants';
import Video from '../Video/Video';
import CTAButton from './CTAButton';
import CTAImage from './CTAImage';

export type TImageSide = 'left' | 'right';

type CalculatorCtaProps = {
  data: CtaComponent;
  articleView?: boolean;
};

const ImageWrapper = ({ children, route }: { children: ReactNode, route: string | undefined }) => {
  if (route) {
    return (
      <a
        href={route}
        className={styles.calculatorCTA__imageWrapper}
      >
        {children}
      </a>
    );
  } else return <div className={styles.calculatorCTA__imageWrapper}>{children}</div>;
};

export default function CalculatorCTA({
  data,
  articleView,
}: CalculatorCtaProps) {
  const isVideo = SUPPORTED_VIDEO_EXTENSIONS.includes(data.media.ext);

  return (
    <section className={classNames(styles.calculatorCTAWrapper, {
      container: !articleView,
    })}
    >
      <div className={classNames(styles.calculatorCTA, {
        [styles.calculatorCTA_leftSide]: data.imageSide === 'left',
      })}
      >
        <div className={styles.calculatorCTA__content}>
          <header className={styles.calculatorCTA__header}>
            <h4 className={classNames(styles.calculatorCTA__title, 'header4', {
              [styles.articleView]: articleView,
            })}
            >
              <AnimatedTitle title={data.title} />
            </h4>
            {data.description && (
              <p className={classNames(styles.calculatorCTA__description, 'bodySmall', {
                [styles.articleView]: articleView,
              })}
              >
                {data.description}
              </p>
            )}
          </header>
          <CTAButton
            route={data.route}
            ctaButton={data.ctaButton}
          />
        </div>
        <ImageWrapper route={data.route}>
          {isVideo ? (
            <Video
              activeIndex={1}
              view='default'
              playMode='in-view'
              videoType='custom'
              videoClassName={styles.ctaVideo}
              video={{
                clip: data.media,
                autoPlay: true,
                loop: true,
              }}
            />
          ) : (
            <CTAImage
              image={data.smallResolutionImage}
              media={data.media}
            />
          )}
        </ImageWrapper>
      </div>
    </section>
  );
}
